<script>
  import Image from "./Image.svelte";
  import { fade, fly } from "svelte/transition";
  import { onMount } from "svelte";

  let isFormOpen = false;
  let isNavOpen = false;
  let navHeight = 0;
  $: navOpen = (isNavOpen)?'is-active':'';
  $: document.body.classList[isNavOpen || isFormOpen ? 'add' : 'remove']('noscroll');
  let _album = "Featured";
  let year = new Date().getFullYear();
  let photos = [];
  let init = false;
  onMount(async () => {
		const res = await fetch(
      "https://storage.googleapis.com/storage/v1/b/littleadeline/o?prefix=" +
        _album +
        "/&delimiter=/"
    );
    const data = await res.json();
    if (data && data.items) {
      photos =  data.items.filter((i) => {
        return !i.name.endsWith("/");
      });
    }
    init = true;
	});

  let w = 0;
  let h = 0;
  $: adjustedHeight = (h < 10)?0:h-10;
  function handleOpenForm() {
    isFormOpen = true;
  }
  function handleCloseForm() {
    isFormOpen = false;
  }
  function toggleNavMenu(){
    isNavOpen = !isNavOpen;
  }
</script>

<main>
  <nav class="c-nav navbar is-transparent" bind:clientHeight={navHeight}>
    <div class="container ">
      <div class="navbar-brand">
        <a class="navbar-item" href="">
          <img src="/assets/logo.png" class="c-logo" alt="" />
        </a>
        <a on:click={toggleNavMenu} role="button" class="navbar-burger {navOpen}" aria-label="menu" aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-end is-hidden-touch">
        <a class="navbar-item" on:click={handleOpenForm}>
          <i class="far fa-envelope" style="margin-right:.5rem" />Contact
        </a>
        <a class="navbar-item" href="https://www.instagram.com/little.adeline.photo/?hl=en">
          <i class="fab fa-instagram" style="margin-right:.5rem"/>little.adeline.photo
        </a>
      </div>
    </div>
  </nav>
  {#if isNavOpen}
    <div class="c-navMenu" transition:fade="{{duration:250}}">
      <aside class="box" >
        <div class="menu">
          <p class="menu-label">
            General
          </p>
          <ul class="menu-list">
            <li><a on:click={handleOpenForm}><i class="far fa-envelope" style="margin-right:.5rem" />Contact</a></li>
            <li><a href="https://www.instagram.com/little.adeline.photo/?hl=en"><i class="fab fa-instagram" style="margin-right:.5rem"/>little.adeline.photo</a></li>
          </ul>
        </div>
      </aside>
      <div class="c-blur" style="height:calc(100vh - {navHeight}px" on:click={()=>{isNavOpen = false}} ></div>
    </div>
  {/if}
  <!-- <section class="hero">
    <div class="hero-body">
      <div class="container">
        <p class="subtitle">Midlands and Upstate South Carolina</p>
      </div>
    </div>
  </section> -->
  <section>
    <div class="container  mb-6">
      <!-- <AlbumSelector/> -->

        {#if init}
          <div class="cols ">
            {#each photos as img (img.id)}
              <div class="col">
                <Image {img} />
              </div>
            {/each}
          </div>
          {#if photos.length == 0}
            <section class="hero is-fullheight">
              <div class="hero-body">
                <div class="container">
                  <p class="title">Well this is Awkward...</p>
                  <p class="subtitle">
                    We're probably doing some backend work, try again later!
                  </p>
                </div>
              </div>
            </section>
          {/if}
        {:else}
        Loading...
        {/if}
    </div>
  </section>
    <div class="modal is-active" class:is-active={isFormOpen}>
      <div class="modal-background" />
      <div class="modal-card c-form">
        <header class="modal-card-head">
          <p class="modal-card-title">Contact</p>
          <button class="delete" aria-label="close" on:click={handleCloseForm}></button>
        </header>
        <section class="modal-card-body " bind:clientWidth={w} bind:clientHeight={h}>
          <iframe
            title="google form"
            src="https://docs.google.com/forms/d/e/1FAIpQLSci2hC_V4oNYh8cFve0WBh_b3dFIySWeb8mwKM62vvM1PD5Uw/viewform?embedded=true"
            width={w}
            height={adjustedHeight}
            frameborder="0"
            marginheight="0"
            marginwidth="0">Loading…</iframe
          >
        </section>
      </div>
    </div>

  <footer class="footer" style="background:none">
    <div class="content has-text-centered">
      <p>
        Copyright &copy; {year} - Little Adeline - All rights reserved
      </p>
    </div>
  </footer>
</main>

<style>
  /*bulma override*/

  .c-logo{
    max-height:2.5rem;
  }
  .c-nav {
    width: 100%;
    background: none;
  }
  .c-navMenu{
    position:absolute;
    left:0;
    width:100%;
    z-index:10;
    
  }
  .c-navMenu>.box{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    position:absolute;
    left:0;
    width:100%;
    z-index:1;
  }
  .c-navMenu>.c-blur{
    width:100%;
    background:rgba(10,10,10,.86);
  }
  .c-form {
    height:100%;
  }
  .c-form .modal-card-body{
    padding:0;
  }
  .cols {
    line-height: 0;

    -webkit-column-count: 4;
    -webkit-column-gap: 1rem;
    -moz-column-count: 4;
    -moz-column-gap: 1rem;
    column-count: 4;
    column-gap: 1rem;
  }
  .col {
    margin-bottom: 1rem;
  }
  @media (max-width: 1023px) {
    .cols {
      -moz-column-count: 3;
      -webkit-column-count: 3;
      column-count: 3;
    }
  }
  @media (max-width: 400px) {
    .cols {
      -moz-column-count: 1;
      -webkit-column-count: 1;
      column-count: 1;
    }
    .c-logo{
      max-height:2rem;
    }
  }
  
  
</style>
